<template>
<nav class="secondary-sidebar padding-30">
  <a href="email_compose.html" class="btn btn-complete btn-block btn-compose m-b-30">Compose</a>
  <p class="menu-title">BROWSE</p>
  <ul class="main-menu">
    <li class="active">
      <a href="#">
        <span class="title"><i class="pg-inbox"></i> Inbox</span>
        <span class="badge pull-right">5</span>
      </a>
    </li>
    <li class="">
      <a href="#">
        <span class="title"><i class="pg-folder"></i> All mail</span>
      </a>
      <ul class="sub-menu no-padding">
        <li>
          <a href="#">
            <span class="title">Important</span>
          </a>
        </li>
        <li>
          <a href="#">
            <span class="title">Labeled</span>
          </a>
        </li>
      </ul>
    </li>
    <li>
      <a href="#">
        <span class="title"><i class="pg-sent"></i> Sent</span>
      </a>
    </li>
    <li>
      <a href="#">
        <span class="title"><i class="pg-spam"></i> Spam</span>
        <span class="badge pull-right">10</span>
      </a>
    </li>
  </ul>
  <p class="menu-title m-t-20 all-caps">Quick view</p>
  <ul class="sub-menu no-padding">
    <li>
      <a href="#">
        <span class="title">Documents</span>
      </a>
    </li>
    <li>
      <a href="#">
        <span class="title">Flagged</span>
        <span class="badge pull-right">5</span>
      </a>
    </li>
    <li>
      <a href="#">
        <span class="title">Images</span>
      </a>
    </li>
  </ul>
</nav>
</template>

<script>
  export default {
    name: "Sidebar"
  }
</script>


// WEBPACK FOOTER //
// sidebar.vue?1a794e7e